import { HOLIDAY_ADD_ACTION_TYPE, HOLIDAY_DELETE_ACTION_TYPE, HOLIDAY_DETAIL_ACTION_TYPE, HOLIDAY_LIST_ACTION_TYPE } from "../../utils/constants";
const initialState = [];
function holidayReducer(state=initialState,action){
    const{type,payload}=action;

    switch(type){
        case HOLIDAY_LIST_ACTION_TYPE:
            return [...state,payload];
        case HOLIDAY_ADD_ACTION_TYPE:
            return [...state,payload];
        case HOLIDAY_DETAIL_ACTION_TYPE:
            return [...state,payload];
        case HOLIDAY_DELETE_ACTION_TYPE:
            return [...state,payload];   
        default:
            return state;
    }
}
export default holidayReducer;